var VLW = (typeof VLW === 'undefined') ? {} : VLW;

function extend(target) {
	for (var i = 1; i < arguments.length; ++i) {
		var from = arguments[i];
		if (typeof from !== 'object') {
			continue;
		}
		for (var j in from) {
			if (from.hasOwnProperty(j)) {
				target[j] = typeof from[j] === 'object' ? extend({}, target[j], from[j]) : from[j];
			}
		}
	}
	j = from = null;
	return target;
}

VLW.stringToFunction = function (str) {
	var arr = str.split(".");
	var fn  = (window || this);
	for (var i = 0, len = arr.length; i < len; i++) {
		fn = fn[arr[i]];
	}
	if (typeof fn !== "function") {
		throw new Error("function not found " + str);
	}
	return fn;
};
VLW.clearMutation    = function (node) {
	[node, ...node.querySelectorAll('[data-vlw-mutation]')].forEach((elt) => {
		(elt.vlwInstance && elt.vlwInstance.instanceClean());
	});
};
VLW.initMutation     = function (node) {
	[node, ...node.querySelectorAll('[data-vlw-mutation]')].forEach((elt) => {
		if (elt.hasAttribute("data-vlw-mutation")) {
			//try {
			let _myClass = VLW.stringToFunction(elt.getAttribute("data-vlw-mutation"));
			if (typeof _myClass === "function") {
				new _myClass(elt);
			}
			//}catch (e) {
			//	console.dir(e);
			//}
		}
	});
};
VLW.init             = function (el, ctrl) {
	let _a = el.querySelectorAll('[data-vlw]');
	for (let i = 0, j = _a.length; i < j; i++) {
		let _class   = _a[i].getAttribute("data-vlw");
		let _myClass = VLW.stringToFunction(_class);
		if (typeof _myClass !== "function") {
		} else {
			//console.log("%c INIT de "+_class,"background-color:#FFDB4F;color:black");
			new _myClass(_a[i], ctrl);
		}
	}
};
VLW.instanceClean    = function (elt) {
	var _instances = elt.querySelectorAll("[data-vlw]");
	if (_instances.length > 0) {
		for (var i = 0, j = _instances.length; i < j; i++) {
			if (_instances[i].vlwInstance) {
				_instances[i].vlwInstance.instanceClean();
			}
		}
	}
	_instances = null;
	elt        = null;
};
VLW.memory           = [];
VLW.classBase        = class {
	constructor(elt) {
		this.initBind(this);
		if (elt != null) {
			this.elt             = elt;
			this.elt.vlwInstance = this;
		}
		this.initAttributeControllerClick();
		this.loadAssets();
		this.autoVars();
	}
	
	loadAssets() {
		if (!this.elt) {return;}
		this.elt.querySelectorAll("[data-style-background]").forEach((elt) => {
			const src   = elt.dataset.styleBackground;
			(new Promise((resolve, reject) => {
				const image  = new Image();
				image.onload = resolve;
				image.src    = src;
			})).then(() => {
				elt.classList.add("_backgroundImageLoaded");
				elt.style.backgroundImage = `url(${src})`;
			});
		});
	}
	
	initBind(currCls) {
		if (currCls == null || typeof currCls === "undefined" || currCls.__proto__ == null || typeof currCls.__proto__ === "undefined") {
			return;
		}
		let names = Object.getOwnPropertyNames(currCls.__proto__);
		for (let memberName of names) {
			// skip getters/setters
			let descriptor = Object.getOwnPropertyDescriptor(currCls.__proto__, memberName);
			if (descriptor && (descriptor.get || descriptor.set)) {
				continue;
			}
			if (typeof (this[memberName]) === "function" && memberName !== "constructor") {
				this[memberName] = this[memberName].bind(this);
			}
		}
		this.initBind(currCls.__proto__);
	}
	
	instanceClean() {
		this.clean_AttributeControllerClick();
		this.clean_AutoVars();
		if (this.elt) {
			this.elt.vlwInstance = null;
			this.elt.removeAttribute("data-vlw");
			this.elt = null;
		}
		for (var i in this) {
			if (this[i] != null && i != "ctrl" && typeof (this[i].instanceClean) == "function") {
				this[i].instanceClean.call(this[i]);
			}
			this[i] = null;
		}
	}
	
	initAttributeControllerClick() {
		var method, scope;
		if (this.elt) {
			this.clicks = this.elt.querySelectorAll("[data-vlw-click]");
			if (this.clicks.length > 0) {
				for (var i = 0, j = this.clicks.length; i < j; i++) {
					method = this.clicks[i].getAttribute('data-vlw-click');
					if (!(scope = window[this.clicks[i].getAttribute('data-vlw-scope')])) {
						scope = this;
					}
					if (scope[method]) {
						this.clicks[i].addEventListener("click", this.controller_action_onClick);
					}
				}
			}
		}
		method = scope = null;
	}
	
	clean_AttributeControllerClick() {
		if (this.clicks && this.clicks.length > 0) {
			for (var i = 0, j = this.clicks.length; i < j; i++) {
				this.clicks[i].removeEventListener("click", this.controller_action_onClick);
				this.clicks[i] = null;
			}
		}
		this.clicks = null;
	}
	
	controller_action_onClick(e) {
		var method, scope, args, aArgs, jp;
		method = e.currentTarget.getAttribute('data-vlw-click');
		if (args = e.currentTarget.getAttribute('data-vlw-click-args')) {
			if (jp = JSON.parse(args)) {
				switch (typeof (jp)) {
					case "string":
					case "number":
						aArgs = [jp, e];
						break;
					case "object":
						if (jp.event && jp.value && window[jp.event] && window[jp.event][jp.value]) {
							aArgs = [window[jp.event][jp.value]];
						}
						break;
				}
			}
		} else {
			aArgs = [e];
		}
		if (!(scope = window[e.currentTarget.getAttribute('data-vlw-scope')])) {
			scope = this;
		}
		if (scope[method]) {
			return scope[method].apply(scope, aArgs);
		}
		method = null;
		scope  = null;
		aArgs  = null;
		args   = null;
	}
	
	autoVars() {
		if (this.elt) {
			var _a = this.elt.querySelectorAll('[data-vlw-autoVars]');
			for (var i = 0, j = _a.length; i < j; i++) {
				var _var   = _a[i].getAttribute("data-vlw-autoVars");
				this[_var] = _a[i];
			}
			_a = _var = null;
		}
	}
	
	clean_AutoVars() {
		if (this.elt) {
			var _a = this.elt.querySelectorAll('[data-vlw-autoVars]');
			for (var i = 0, j = _a.length; i < j; i++) {
				var _var   = _a[i].getAttribute("data-vlw-autoVars");
				this[_var] = null;
			}
			_a = _var = null;
		}
	}
};
